import { zfTranslations } from "./zf_translations";
import { zfUtils } from "./zf_utils";
import { zfccd } from "./zfc_dialog";
import { zfch2 } from "./zfc_header";
export class zfcmwf {
    static showSurvey() {
        try {
            if (localStorage.getItem("zfcmwf-feedback-survey") == "opt_out" ||
                sessionStorage.getItem("zfcmwf-feedback-survey") == "opt_out")
                return;
            if (!zfch2.globalSettings.hasOwnProperty("feedback_survey") ||
                zfch2.globalSettings.feedback_survey.data.length == 0)
                return;
            if (sessionStorage.getItem("zfcmwf-feedback-survey") != null) {
                var startTime = new Date(sessionStorage.getItem("zfcmwf-feedback-survey"));
                var surveyTimeDiff = zfch2.globalSettings.feedback_survey.time * 1000 -
                    (new Date().getTime() - startTime.getTime());
                if (surveyTimeDiff < 0) {
                    var config = {
                        title: zfTranslations.get("feedback_survey.take_survey_question"),
                        dialogSize: "medium",
                        buttons: [
                            {
                                trans: "yes",
                                callback: function () {
                                    localStorage.setItem("zfcmwf-feedback-survey", "opt_out");
                                    zfccd.removeBtns();
                                    zfccd.updateTitle(null);
                                    zfccd.updateContent(zfch2.globalSettings.feedback_survey.data);
                                    zfcmwf.init();
                                    zfccd.addBtn({
                                        trans: "opt_out",
                                        callback: function () {
                                            zfccd.close();
                                            localStorage.setItem("zfcmwf-feedback-survey", "opt_out");
                                        },
                                    });
                                    zfccd.addBtn({
                                        trans: "feedback_survey.remind_later",
                                        callback: function () {
                                            zfccd.close();
                                            localStorage.removeItem("zfcmwf-feedback-survey");
                                            sessionStorage.setItem("zfcmwf-feedback-survey", "opt_out");
                                        },
                                    });
                                },
                            },
                            {
                                trans: "no",
                                callback: function () {
                                    zfccd.close();
                                    localStorage.setItem("zfcmwf-feedback-survey", "opt_out");
                                },
                            },
                            {
                                trans: "feedback_survey.remind_later",
                                callback: function () {
                                    zfccd.close();
                                    localStorage.removeItem("zfcmwf-feedback-survey");
                                    sessionStorage.setItem("zfcmwf-feedback-survey", "opt_out");
                                },
                            },
                        ],
                    };
                    sessionStorage.removeItem("zfcmwf-feedback-survey");
                    zfccd.showDialog(config);
                }
                else
                    setTimeout(zfcmwf.showSurvey, surveyTimeDiff);
            }
            else {
                sessionStorage.setItem("zfcmwf-feedback-survey", new Date().toISOString());
                setTimeout(zfcmwf.showSurvey, zfch2.globalSettings.feedback_survey.time * 1000);
            }
        }
        catch (err) {
            console.log("function failed: zfcmap.showSurvey() " + err.message);
        }
    }
    static init() {
        try {
            var FormCapture365 = false;
            var FormCapture365Id;
            if (jQuery(".mwfAjaxReplace").length > 0)
                $.ajax({
                    type: "GET",
                    url: location.hostname.includes("-kons")
                        ? "https://www-kons.zf.com/utils/formcentric/initLibs.js"
                        : "https://www.zf.com/utils/formcentric/initLibs.js",
                    dataType: "script",
                    cache: true,
                }).done(function () {
                    jQuery(".mwfAjaxReplace").each(function (index, item) {
                        var mwf_that = jQuery(item);
                        var language = item.lang.length > 2
                            ? item.lang
                            : item.lang.toLocaleLowerCase() + "_" + item.lang;
                        if (mwf_that.attr("features") == "365FormCapture") {
                            FormCapture365 = true;
                            FormCapture365Id = item.id;
                        }
                        if (item.id != "") {
                            jQuery.mwfAjaxReplace({
                                selector: "#" + item.id,
                                uid: item.id,
                                dataType: "jsonp",
                                url: "/fc_live/servlet/form",
                                appendUrlVars: true,
                                data: {
                                    _view: "webform",
                                    _fd: mwf_that.attr("encrypted"),
                                    _refs: mwf_that.attr("refs"),
                                    _lang: language,
                                    _ticket: mwf_that.attr("ticket"),
                                },
                            });
                        }
                    });
                });
            if (FormCapture365) {
                $.getScript("https://cxppusa1formui01cdnsa01-endpoint.azureedge.net/usa/FormCapture/FormCapture.bundle.js").done(function () {
                    globalThis["d365mktformcapture"]
                        .waitForElement("#command" + FormCapture365Id)
                        .then(function (form) {
                        const mappings = [];
                        $.each(form, function (i, input) {
                            if (input.type == "text")
                                mappings.push({
                                    FormFieldName: input.name,
                                    DataverseFieldName: input.name,
                                });
                        });
                        $(".mwf-button--submit")
                            .off("click.zfcmwf")
                            .on("click.zfcmwf", function () {
                            const serializedForm = globalThis["d365mktformcapture"].serializeForm(form, mappings);
                            const payload = serializedForm.SerializedForm.build();
                            const captureConfig = {
                                FormId: "33adcde2-2dfb-ee11-a1ff-000d3a9986f7",
                                FormApiUrl: "https://public-usa.mkt.dynamics.com/api/v1.0/orgs/2ef0735b-583e-4f3c-98f8-28927c20b309/landingpageforms",
                            };
                            globalThis["d365mktformcapture"].submitForm(captureConfig, payload);
                        });
                    });
                });
            }
        }
        catch (err) {
            console.log("Initalization failed: zfcmap.initItem() " + err.message);
        }
    }
}
zfcmwf.initialized = false;
zfUtils.onReady(zfcmwf.init);
